import { render } from "./RegionDetails.vue?vue&type=template&id=3c667acc&scoped=true"
import script from "./RegionDetails.vue?vue&type=script&lang=js"
export * from "./RegionDetails.vue?vue&type=script&lang=js"

import "./RegionDetails.vue?vue&type=style&index=0&id=3c667acc&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c667acc"]])

export default __exports__